// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__r_bdm","content":"styles_content__1BKg1","row":"styles_row__ZGb8B","footer":"styles_footer__2KzNM","phraseLength":"styles_phraseLength__34bOA"};